export default (selectedIds, token) => {
  const apiRoot = (process.env.NODE_ENV === 'development') ? 'http://localhost:3001' : '';
  const ids = JSON.stringify(selectedIds);
  const downloadUrl = `${apiRoot}/api/items/zip?ids=${ids}&token=${token}`;
  window.location.replace(downloadUrl) 
}